import Vue from "vue";
import _ from "lodash";
import Vuex from "vuex";
import axios from "axios";
import router from "../router";
import { Dialog, Toast } from "vant";
import moment from "moment";
import { showNocifaction } from "@/utils/commonNotifaction";
import { data } from "autoprefixer";
Vue.use(Vuex);
import {
  checkUserLogin,
  getClient,
  getProjectInfo,
  getAuthUserInfo
} from "@/api/api";

function getWindDirectionDesc(degree) {
  if (degree) {
    let descs = ["北", "东北", "东", "东南", "南", "西南", "西", "西北"];
    let index = Math.floor((degree + 22.5) / 45) % 8;
    return descs[index];
  } else {
    return "";
  }
}

function downloadNew(fileURL) {
  var fileTransfer = new FileTransfer();
  var url = "http://jnwz.novaecs.com/androidapp/guanxian/apks/app-debug.apk";
  var filename = url.split("/").pop();
  var targetPath = cordova.file.externalRootDirectory + filename;
  fileTransfer.onprogress = function(progressEvent) {
    window.mainapp.showProcess = true;
    if (progressEvent.lengthComputable) {
      // loadingStatus.setPercentage(progressEvent.loaded / progressEvent.total);
      var text = parseInt((progressEvent.loaded / progressEvent.total) * 100);
      window.mainapp.processText = text;
      if (text == 100) {
        window.mainapp.showProcess = false;
      }
    } else {
      // loadingStatus.increment();
    }
  };
  fileTransfer.download(
    url,
    targetPath,
    function(entry) {
      console.log("download complete: " + entry.toURL());
      cordova.plugins.fileOpener2.open(
        targetPath,
        "application/vnd.android.package-archive",
        {
          error: function(e) {
            console.log(e);
          },
          success: function(r) {
            console.log(r);
          }
        }
      );
    },
    function(error) {
      console.log(error);
    }
  );
}

function processInfo(process) {
  console.log("process");
  var downloadProgress = (progress.loaded / progress.total) * 100;
  window.showProcess = true;
  // window.processText="已经下载：" + Math.floor(downloadProgress) + "%"
  window.processText = downloadProgress;
  if (downloadProgress > 99) {
    window.showProcess = false;
    clearInterval(t1);
  }
}

function checkVersion(msg = false) {
  var code = window.shortCode || "et1k4p";
  if (!code) {
    // Toast('检查更新失败');
    return;
  }
  axios_base
    .get("https://fabu.it.novaecs.com/api/app/" + code)
    .then(function(resp) {
      var data = resp.data;
      var versionRemote = data.data.version.versionStr;
      cordova.getAppVersion
        .getVersionNumber()
        .then(function(version) {
          window.app_version = version;
          if (version != versionRemote) {
            // update
            /* document.addEventListener('deviceready', onDeviceReady);
        function onDeviceReady(){
          var success = function(status) {
            console.log(status)
            // Toast.success('清除成功');
          }
          var error = function(status) {
            console.log(status)
            // Toast.fail('清除失败');
          }
          window.cache.clear( success, error );
        } */

            Dialog.confirm({
              title: "升级提示",
              message: `发现新版本，是否马上升级？`
            })
              .then(() => {
                window.location.href = data.data.version.installUrl;
              })
              .catch(() => {
                // on cancel
              });
          } else {
            if (msg) {
              Toast("已是最新版本");
            }
          }
        })
        .catch(function(e) {
          console.log(e);
        });
    });
}

export { checkVersion };
export default new Vuex.Store({
  state: {
    app_id: 10060,
    clientInfo: {},
    projectInfo: {},
    count: 0,
    option_region: [],
    stations: [],
    pm_avg: 0,
    userInfo: {},
    userGroups: [],
    userList: "",
    publishedTasks: "",
    myTasks: "",
    group_info: [],
    city_station_id: "",
    virtualList: [],
    alarmList: [],
    mapStatus: {
      point: null,
      zoom: null
    },
    rankStatus: {},
    loginAsDefault: false,
    loginType: "input",
    defaultUserInfo: {},
    gfStation: [],
    gfStationData: [],
    hideBackBtn: false
  },
  getters: {
    option_data_type(state) {
      let sensorType = state.projectInfo.sensorType
      if (state.userInfo && state.userInfo.userExtraInfo && state.userInfo.userExtraInfo.sensorType) {
        sensorType = state.userInfo.userExtraInfo.sensorType
      }
      if (!sensorType) {
        return []
      }
      let sensorTypeInfo = []
      for(let item of sensorType.split(',')) {
        G_SENSOR_DATA_TYPE_INFO.filter(x => {
            if (x.value == item) {
                sensorTypeInfo.push(x)
            }
        })
      }
      return sensorTypeInfo
    }
  },
  mutations: {
    setLoginAsDefault(state, v) {
      state.loginAsDefault = v;
    },
    setLoginType(state, v) {
      state.loginType = v;
    },
    setDefaultUserInfo(state, v) {
      state.defaultUserInfo = v;
    },
    setClientInfo(state, data) {
      state.clientInfo = data;
    },
    setProjectInfo(state, data) {
      state.projectInfo = data;
    },
    setAuthUserInfo(state, data) {
      state.userInfo = data;
      checkVersion();
    },
    increment(state) {
      state.count++;
    },
    updateRegionOptions(state, region_data) {
      state.option_region = region_data;
    },
    getUserStations(state, stations) {
      state.stations = stations;
    },
    calcPmAvg(state, avg) {
      state.pm_avg = avg;
    },
    getUserByGroups(state, userGroups) {
      state.userGroups = userGroups;
    },
    getUserList(state, userList) {
      state.userList = userList;
    },
    getUserPublishedTasks(state, publishedTasks) {
      state.publishedTasks = publishedTasks;
    },
    getMyTask(state, myTasks) {
      state.myTasks = myTasks;
    },
    setToken(state) {
      console.log("set token");
      var token = localStorage.getItem("yc_token");
      axios.defaults.headers.common["token"] = token;
    },
    getUserGroups(state, group_info) {
      state.group_info = group_info;
    },
    setCityStationId(state, v) {
      state.city_station_id = v;
    },
    updateVirtual(state, data) {
      state.virtualList = data;
    },
    updateAlarmList(state, data) {
      state.alarmList = data;
    },
    updateMapSatus(state, data) {
      state.mapStatus = data;
    },
    updateRankStatus(state, data) {
      state.rankStatus = data;
    },
    updateGfStation(state, data) {
      state.gfStation = data;
    },
    updateGfStationData(state, data) {
      state.gfStationData = data;
    },
    setHideBackBtn(state, value){
      state.hideBackBtn = value
    }
  },
  actions: {
    async init({ dispatch, commit }, callback) {
      // try {
      var res = await checkUserLogin();
      if (res.data.code === 200) {
        Promise.all([
          await dispatch("getClient", localStorage.getItem("u_username")),
          await dispatch("getProjectInfo"),
          await dispatch("getAuthUserInfo"),
        ])
          .then(() => {})
          .catch(e => {
            console.log(e);
          });
        callback && callback(true);
      } else {
        router.replace({ name: "login" });
        callback && callback(false);
      }
      // } catch (e) {
      //   console.log(e);
      //   callback && callback()
      //   router.replace({ name: "login" });
      // }
    },
    getClient(context, username) {
      return getClient(username).then(c => {
        if (c.data.code === 200) {
          context.commit("setClientInfo", c.data.data);
        }
      });
    },
    getProjectInfo(context) {
      return getProjectInfo(context.state.clientInfo.proId).then(res => {
        const { code, msg, data } = res.data;
        if (code == 200) {
          let name = (data.city || "") + (data.county || "");
          let regionId = data.countyCode || data.cityCode;
          data.name = name;
          data.regionId = regionId;
          context.commit("setProjectInfo", data);
        } else {
          message.error(msg);
        }
      });
    },
    getAuthUserInfo({ state, dispatch, commit }) {
      return getAuthUserInfo(state.clientInfo.proId).then(resp => {
        let userInfo = resp.data.data;
        commit("setAuthUserInfo", userInfo);
        showNocifaction();
        axios_base
          .get(
            `wz/getVirtualStations/1?type=1&group_id=${userInfo.devGroupIds}`
          )
          .then(x => {
            if (x.data && x.data.length === 0) {
              /* commit("updateRegionOptions", [
                {
                  label: "全部",
                  value: "all"
                }
              ]); */
              commit("setCityStationId", null);
            } else {
              /* let region_option = x.data
                .map(item => ({
                  ...item,
                  label: item.name,
                  value: item.group_id
                }))
                .sort((a, b) => parseInt(a.value) - parseInt(b.value));
              commit("updateRegionOptions", region_option); */
              commit(
                "setCityStationId",
                x.data[0].station_id || x.data[0].sn
              );
            }
          })
          .catch(e => {
            console.log(e);
            commit("setCityStationId", null);
          }
        );
        var end_t = moment().format("YYYY-MM-DD HH:mm:ss");
        var start_t = moment()
          .subtract(3, "days")
          .format("YYYY-MM-DD HH:mm:ss");
        dispatch("getAlarmList", { start_t, end_t });
        dispatch("getGfStation")
      });
    },
    increment(context) {
      context.commit("increment");
    },
    getUserStations(context, kwargs) {
      if (kwargs.groups && kwargs.timep) {
        var self = this;
        var fields = ["pm25", "pm10", "shidu", "wendu", "wind_speed"];
        var url =
          "yc2/getStationRank?groups=" + kwargs.groups + "&time_type=" + kwargs.timep;
        if (kwargs.timepoint) {
          url = url + `&timepoint=${kwargs.timepoint}`;
        }
        var pm10_sum = 0;
        var pm10_len = 0;
        return axios_base
          .get(url)
          .then(function(resp) {
            var stations = resp.data;
            // 获取最新时间
            let lastTime = stations[0].sensor.TIME;
            let sortData = stations.filter(item => item.sensor.TIME).sort((a, b) => moment(b.sensor.TIME).unix() - moment(a.sensor.TIME).unix());
            if(sortData.length) {
              lastTime = sortData[0].sensor.TIME;
            }
            // 将时间不是最新的值设置为null
            stations = stations.map(item => {
              if(item.sensor.TIME && item.sensor.TIME !== lastTime) {
                item.sensor['pm10'] = null;
                item.sensor['pm25'] = null;
              }
              return item;
            })

            const {add_rz_region} = _page_config
            let regionOption = [{label: "全部", value: 0}]
            if(add_rz_region) {
              regionOption = [{label: "日照", value: 0}]
            }

            for (var i in stations) {
              var pm25 = stations[i].sensor.pm25;
              var pm10 = stations[i].sensor.pm10;
              var wendu = stations[i].sensor.wendu;
              var shidu = stations[i].sensor.shidu;
              //   var pm25_color = getPMInfo(pm25,"pm25")
              //   var pm10_color = getPMInfo(pm10,"pm10")

              if (wendu) {
                stations[i].sensor.wendu = parseInt(wendu);
              }
              if (shidu) {
                stations[i].sensor.shidu = parseInt(shidu);
              }
              if (pm10) {
                pm10_sum += pm10;
                pm10_len += 1;
              } else {
                stations[i].sensor.pm10 = null;
                // pm25_color = {"lowval_pm25":-10,"highval_pm25":0,"lowval_pm10":-10,"highval_pm10":0,"description":"掉线","bgcolor":"#666666","fgcolor":"#ffffff","type":"valid"}
              }
              if (!pm25) {
                stations[i].sensor.pm25 = null;
                // pm10_color = {"lowval_pm25":-10,"highval_pm25":0,"lowval_pm10":-10,"highval_pm10":0,"description":"掉线","bgcolor":"#666666","fgcolor":"#ffffff","type":"valid"}
              }

              stations[i].sensor.direction = getWindDirectionDesc(
                stations[i].sensor.wind_direction
              );
              //   stations[i].color = {pm25_color:pm25_color.bgcolor, pm10_color:pm10_color.bgcolor, pm25_font_color:pm25_color.fgcolor,  pm10_font_color:pm10_color.fgcolor}
              for (var f in G_SENSOR_DATA_TYPE_INFO) {
                var v = stations[i].sensor[f.value];
                if (v) {
                  if (v > 100) {
                    stations[i].sensor[f.value] = parseInt(v);
                  }
                }
              }
              // 反查区域分组
              if(stations[i] && stations[i].path) {
                const {name3, id3, name2, id2} = stations[i].path;
                regionOption.push({value: id3, label: name3})
                regionOption.push({value: id2, label: name2})
              }
            }
            regionOption =_.uniqBy(regionOption, 'value')
            console.log("🚀 ~ file: index.js ~ line 406 ~ .then ~ regionOption", regionOption)
            context.commit("updateRegionOptions", regionOption)
            var pm10_avg = pm10_sum / pm10_len;
            context.commit("calcPmAvg", pm10_avg);
            context.commit("getUserStations", stations);
          })
          .catch(e => {
            context.commit("calcPmAvg", null);
            context.commit("getUserStations", []);
          });
      }
    },
    getUserByGroups(context) {
      return axios_base
        .get("yc2/getUserByGroups?app_id=" + siteConfig.app_id)
        .then(function(resp) {
          context.commit("getUserByGroups", resp.data);
        });
    },
    getUserList({ commit, state }) {
      return axios_base
        .get("yc2/getUserList?app_id=" + state.app_id)
        .then(function(resp) {
          commit("getUserList", resp.data);
        });
    },
    getUserPublishedTasks(context) {
      return axios_base
        .get("session/getUserPublishedTasks")
        .then(function(resp) {
          context.commit("getUserPublishedTasks", resp.data);
        });
    },
    getMyTask(context, kwargs) {
      return axios_base
        .get(
          `session/getMyTask?page=${kwargs.page}&page_num=${kwargs.page_num}`
        )
        .then(function(resp) {
          context.commit("getMyTask", resp.data);
        });
    },
    getUserGroups(context) {
      return axios_base.get("user/getUserGroup").then(function(resp) {
        var data = resp.data;
        context.commit("getUserGroups", data);
      });
    },
    getVirtualDevice(context, group_id) {
      return axios_base
        .get(
          `wz/getVirtualStationsWithoutRegion/33?type=5&group_id=${group_id}`
        )
        .then(res => {
          const { status, statusText, data } = res;
          if (status === 200) {
            context.commit("updateVirtual", data);
          } else {
            throw new Error(statusText);
          }
        })
        .catch(err => {
          context.commit("updateVirtual", []);
        });
    },
    getAlarmList(context, { start_t, end_t }) {
      return axios_base
        .get(`session/getAlarmList?start_t=${start_t}&end_t=${end_t}`)
        .then(res => {
          const { status, statusText, data } = res;
          if (status === 200) {
            context.commit("updateAlarmList", data);
          } else {
            throw new Error(statusText);
          }
        })
        .catch(err => {
          context.commit("updateAlarmList", []);
        });
    },
    loginAsDefault(context) {
      return new Promise((resolve, reject) => {
        axios_base
          .post("user/Login", context.state.defaultUserInfo)
          .then(function(resp) {
            if (resp.data.token) {
              localStorage.setItem("yc_token", resp.data.token);
              context.commit("setToken");
              context.commit("setLoginAsDefault", true);
              router.replace({ name: "index" });
              resolve(1);
            } else {
              reject(0);
            }
          }).catch(e=>{
            reject(e);
          });
      });
    },
    // 获取标站信息
    getGfStation({state, commit, dispatch}) {
      return axios.get(`http://gf.novaecs.com/api/gf_manage/station/?region_id=${state.projectInfo.regionId}&station_type=水质`).then(res=>{
      console.log("getGfStation -> res", res)
        let {status, data, msg} = res.data;
        if(status == 0) {
          commit("updateGfStation", data);
          dispatch("getGfStationData", {});
        } else {
          console.log(msg);
        }
      }).catch(err => {
        console.log(err);
      })
    },
    getGfStationData({state, commit}, {start_t, type}){
      commit("updateGfStationData", []);
      const sns = state.gfStation.map(item => item.sn).join(",");
      let url = `http://gf.novaecs.com/api/gf_manage/station_data/?station_type=水质&sn=${sns}`
      if(start_t && type) {
        url += `&start_t=${start_t}&time_type=${type}`
      }
      console.log("getGfStationData -> url", url)
			return axios.get(url).then(res=>{
      console.log("getGfStationData -> res", res)
          let {status, data, msg} = res.data;
          if(status == 0) {
            data = state.gfStation.map(item => {
              for(let s of data) {
                if(item.sn == s.sn) {
                  item = {...item, ...s}
                }
              }
              var aa=coordtransform.wgs84togcj02(item.lng,item.lat)
              var bb=coordtransform.gcj02tobd09(aa[0],aa[1])
              item.lng = bb[0]
              item.lat = bb[1]
              return item;
            })
            return commit("updateGfStationData", data);
          } else {
            console.log(msg);
          }
      }).catch(err => {
        console.log(err);
      })
		},
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js